import styled, { css } from 'styled-components'

import { Hexagon } from '../styles'

import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  position: relative;
  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl5}px;

    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.lg}px;
      margin-top: ${theme.newSpaces.xl2}px;
    `}
  `}
`

export const GrayHexagon = styled(Hexagon)`
  display: none;
  left: -45%;
  top: 25%;

  ${({ theme }) => css`
    ${theme.below.laptopL`
      display: block;
    `}

    ${theme.below.laptopM`
      display: none;
    `}
  `}
`

export const OrangeHexagon = styled(Hexagon)`
  display: none;
  right: -30%;
  top: 25%;

  ${({ theme }) => css`
    ${theme.below.laptopL`
      display: block;
    `}

    ${theme.below.laptopM`
      display: none;
    `}
  `}
`
